import { PolicyModelV1 } from '@/lib/models/policy-model-v1/policy-v1.model';
import { FC } from 'react';
import AllowWarningToast from './allow-warning-toast';

interface Props {
  policy: PolicyModelV1;
}

const PsAllowWarningToast: FC<Props> = ({ policy }) => {
  const { allowsPublicServices } = policy;

  if (!allowsPublicServices) {
    return null;
  }

  return (
    <AllowWarningToast
      variant="acl"
      message={`WARNING: This setting has no effect, since the Default Service Action is set to "Allow"`}
    />
  );
};

export default PsAllowWarningToast;
